import { api, unwrap } from './http';

export default {
  getTenantSettings: async () => unwrap(api.post('/Account/GetTennantSettings')),

  // Unified-identity (V2) auth — the legacy endpoint/flag is retired. Returns the admin
  // UserAccessIData (incl. token) on success, or null for bad credentials (401). A 403
  // (valid account without web-admin access) propagates so the caller can show the
  // backend's "sign in with the mobile app" message instead of a generic credentials error.
  login: async (email, password) => {
    try {
      const res = await unwrap(api.post('/Auth/Login', { email, password, surface: 'fe-admin' }));
      return res && res.status === 'Success' && res.admin ? res.admin : null;
    } catch (err) {
      if (err && err.response && err.response.status === 401) return null;
      throw err;
    }
  },

  // Unified-identity (V2) password reset — UserAccount-backed and tenant-agnostic, so it works for
  // admins/trainers too. The emailed code IS the token: it is passed to both verify and complete
  // (there is no separate server-issued reset token). Serves both the interactive "forgot password"
  // flow and the staff onboarding "set your password" magic link.
  resetPasswordRequest: async (email, languageCode = 'en') => unwrap(api.post('/Auth/Reset/Password/Request', { email, languageCode })),

  verifyResetPasswordCode: async (email, token) => unwrap(api.post('/Auth/Reset/Password/Code/Verify', { email, token })),

  completePasswordReset: async ({
    email, token, newPassword, confirmPassword,
  }) => unwrap(api.post('/Auth/Reset/Password/Complete', {
    email, token, newPassword, confirmPassword,
  })),
};
